module.exports = __webpack_public_path__ + "static/img/img-special-tech-price.7c8431b5.png";